import axios from "axios";
import { getToken } from "./utils/auth";

const baseURL = "https://report-node.rupioo.com/api";
// const baseURL = "http://192.168.29.59:5000/api";
console.log("API baseURL is:", baseURL);

const API = axios.create({ baseURL });

// Automatically attach token to headers
API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
